import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPayment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#5C78C7"
        d="M11.5 11a2.4 2.4 0 0 1-1.77-.73A2.4 2.4 0 0 1 9 8.5q0-1.042.73-1.77A2.4 2.4 0 0 1 11.5 6a2.4 2.4 0 0 1 1.77.73q.73.728.73 1.77a2.4 2.4 0 0 1-.73 1.77 2.4 2.4 0 0 1-1.77.73m-6 2q-.618 0-1.06-.441a1.45 1.45 0 0 1-.44-1.06V5.494q0-.62.44-1.056A1.45 1.45 0 0 1 5.5 4h12q.62 0 1.06.441.44.44.44 1.06v6.005q0 .62-.44 1.056A1.45 1.45 0 0 1 17.5 13zM7 11.5h9q0-.626.44-1.065.44-.44 1.06-.44V7q-.62 0-1.06-.44A1.45 1.45 0 0 1 16 5.5H7q0 .626-.44 1.065-.44.44-1.06.44V10q.619 0 1.06.44.44.442.44 1.06m8.75 4.5H2.5q-.62 0-1.06-.44A1.45 1.45 0 0 1 1 14.5V6.75q0-.319.214-.534A.72.72 0 0 1 1.746 6q.316 0 .535.216a.72.72 0 0 1 .219.534v7.75h13.25q.319 0 .534.214a.72.72 0 0 1 .216.532q0 .316-.216.535a.72.72 0 0 1-.534.219"
      />
    </g>
  </svg>
);
export default SvgPayment;
